"use strict";var s=require("joi");require("../types/default-validation-messages.enums.js");var e=require("../types/validator.constants.js");const a=s.defaults((s=>s.messages(e.defaultMessages)));exports.joi=a;
//# sourceMappingURL=joi.js.map
